import React from 'react'
import { Grid, Button, Box, Typography } from '@mui/material'
import {
  marketingSectionSx,
  marketingHeadingSx,
  marketingSubheadingSx,
  marketingProcessStepSx,
  marketingLeadSx,
} from '@/housefolios-components/PublicPages/publicPageSx'

/**
 * Process section component for public home page
 * Shows the 3-step process for buying properties
 */
const ProcessSection = ({ orgName, marketplaceVideoURL  }) => {
  const steps = [
    {
      image: '/images/icons/undraw_setup_wizard_r6mr.png',
      title: 'Step 1',
      description: 'Identify the properties you are interested in.',
    },
    {
      image: '/images/icons/undraw_calling_kpbp.png',
      title: 'Step 2',
      description: 'Schedule a time to discuss at your convenience.',
    },
    {
      image: '/images/icons/undraw_for_sale_viax.png',
      title: 'Step 3',
      description: 'Buy the properties that are right for you!',
    },
  ]

  return (
    <Box component="section" sx={marketingSectionSx} id="sellproperty">
      <Grid container>
        {marketplaceVideoURL && (
          <Grid size={12} sx={{ display: 'flex' }}>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                width: '100%',
                mb: '3rem',
              }}
            >
              <iframe
                src={marketplaceVideoURL}
                width="100%"
                height="564"
                frameBorder="0"
                allow="autoplay; fullscreen"
                allowFullScreen
              />
            </Box>
          </Grid>
        )}

        <Grid
          size={12}
          container
          direction="row"
          sx={{ justifyContent: 'center' }}
        >
          <Grid size={12} style={{ textAlign: 'center' }}>
            <Typography variant="h2" component="h2" sx={marketingHeadingSx}>
              Buy Properties on {orgName ? orgName : 'Housefolios'}{' '}
              Marketplace
            </Typography>
            <Typography variant="h3" component="h3" sx={marketingSubheadingSx} />
          </Grid>
        </Grid>

        <Grid size={12} container direction="row">
          {steps.map((step, index) => (
            <Grid size={{ xs: 12, sm: 4 }} key={index}>
              <Box sx={marketingProcessStepSx}>
                <Box
                  component="img"
                  src={step.image}
                  alt=""
                  sx={{ mx: 'auto', borderRadius: '50%' }}
                />
                <Typography variant="h4" component="h4" sx={{ mt: '25px', mb: 0, textTransform: 'none' }}>
                  {step.title}
                </Typography>
                <Typography sx={{ color: '#a6a6b9', mt: 0 }}>
                  {step.description}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>

        <Grid
          size={12}
          container
          direction="row"
          sx={{ justifyContent: 'center' }}
        >
          <Grid
            size={{ xs: 12, lg: 8 }}
            style={{ textAlign: 'center' }}
          >
            <Typography sx={marketingLeadSx}>
              Buying property has never been easier. We run the
              financial estimates to make sure you find deals inside
              of your buy buckets.
            </Typography>
            {marketplaceVideoURL && (
              <Button
                variant="contained"
                color="primary"
                component="a"
                href={marketplaceVideoURL}
                target="_blank"
                style={{
                  color: 'white',
                  fontWeight: 700,
                  padding: '0.5rem 1rem',
                  fontSize: '1.25rem',
                  lineHeight: '1.5',
                  marginLeft: 5,
                }}
              >
                Get Pre Approved
              </Button>
            )}
          </Grid>
        </Grid>
      </Grid>
    </Box>
  )
}

export default ProcessSection
